import AlarmCentralPartitionCard from '../../_components/AlarmCentralPartitionCard';
import { IAlarmCentralProps } from '../../../../../services/AlarmCentralService/types';
import { AlarmCentralEndpoint } from '../../../../../services/AlarmCentralService/enums';
import {
  useArmPhysicalByPartitionAlarmCentral,
  useDisarmPhysicalByPartitionAlarmCentral,
} from '../../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import { Grid2 } from '@mui/material';
import { useEffect, useState } from 'react';
import { IAlarmCentralJflStatusProps } from '../../../../../services/AlarmCentralService/Physical/Jfl/types';
import { PartitionStatusJfl } from '../../../../../services/AlarmCentralService/Physical/Jfl/enums';
import { IAlarmCentralIntelbrasStatusProps } from '../../../../../services/AlarmCentralService/Physical/Intelbras/IsecNetV2/types';

interface AlarmCentralPhysicalIntelbrasPartitionsProps {
  status: IAlarmCentralIntelbrasStatusProps;
  alarmCentral: IAlarmCentralProps;
}

const AlarmCentralPhysicalIntelbrasPartitions = ({
  status,
  alarmCentral,
}: AlarmCentralPhysicalIntelbrasPartitionsProps) => {
  const [isLoadingPartition, setIsLoadingPartition] = useState<boolean[]>([]);
  const {
    mutateAsync: mutateArmPhysicalByPartitionAlarmCentral,
    isLoading: isLoadingArmPhysicalByPartitionAlarmCentral,
  } = useArmPhysicalByPartitionAlarmCentral();
  const {
    mutateAsync: mutateDisarmPhysicalByPartitionAlarmCentral,
    isLoading: isLoadingDisarmPhysicalByPartitionAlarmCentral,
  } = useDisarmPhysicalByPartitionAlarmCentral();

  const onArmOrDisarm = (index: any, isArm: boolean) => {
    const loading = [...isLoadingPartition];
    loading[index] = true;
    setIsLoadingPartition(loading);

    if (isArm)
      mutateArmPhysicalByPartitionAlarmCentral({
        endpoint:
          AlarmCentralEndpoint.ALARM_CENTRAL_INTELBRAS_ISECNET_V2_ENDPOINT,
        partition: index + 1,
        id: alarmCentral.id,
      });
    else {
      mutateDisarmPhysicalByPartitionAlarmCentral({
        endpoint:
          AlarmCentralEndpoint.ALARM_CENTRAL_INTELBRAS_ISECNET_V2_ENDPOINT,
        partition: index + 1,
        id: alarmCentral.id,
      });
    }
  };

  useEffect(() => {
    const isLoading: boolean[] = [];
    for (let i = 0; i < alarmCentral.partitionQuantity; i++)
      isLoading[i] = false;
    setIsLoadingPartition(isLoading);
  }, [status]);

  return (
    <>
      {[...Array(alarmCentral.partitionQuantity)].map((_, index) => {
        const p = status.partitionsStatus[index];
        if (!p.isEnabled) return <>{p.isEnabled}</>;

        return (
          <Grid2 size={{ xs: 12 }} key={index}>
            <AlarmCentralPartitionCard
              onArmOrDisarm={() => onArmOrDisarm(index, !p.isArmed)}
              isLoadingArmOrDisarm={isLoadingPartition[index]}
              isArmed={p.isArmed}
              account={alarmCentral.account}
              name={'Partição ' + (index + 1)}
              isVirtual={false}
            />
          </Grid2>
        );
      })}
    </>
  );
};

export default AlarmCentralPhysicalIntelbrasPartitions;
